import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-toggle-three',
  templateUrl: './custom-toggle-three.component.html',
  styleUrls: ['./custom-toggle-three.component.scss']
})
export class CustomToggleThreeComponent implements OnInit {

  constructor() { }
  @Input() Value: any;
  @Output() ChangeValue  = new EventEmitter<any>();
  ngOnInit(): void {
  }


  changeValue() {
    if (this.Value == 2)
      this.Value = 1;
    else
      this.Value = 2;

      
    this.ChangeValue.emit(this.Value);
  }
}
